import * as React from 'react';
import { useMutation, useQuery } from 'urql';

import { useNavigate } from 'react-router-dom';
import Loader from '../../shared/components/Loader';
import getLocale from '../../shared/getLocale';
import t from '../../shared/translations';
import Error from '../components/Error';
import PulseForm, { IFormValues } from './PulseForm';
import { ICreateArgs, ICreateData, IQuestionsData, createMutation, questionsQuery } from './queries';

function Setup(): JSX.Element {
    const [createResult, executeCreate] = useMutation<ICreateData, ICreateArgs>(createMutation);
    const navigate = useNavigate();
    const [result] = useQuery<IQuestionsData>({ query: questionsQuery });

    if (result.fetching) {
        return <Loader />;
    } else if (result.error) {
        return <Error />;
    }

    const onSubmit = async (values: IFormValues) => {
        if (createResult.fetching) {
            return;
        }
        const args: ICreateArgs = {
            data: {
                locale: getLocale(),
                question1: values.question1,
                question2: values.question2,
            },
        };
        const result = await executeCreate(args);
        if (result.error || (result.data.pulseCreate && result.data.pulseCreate.error)) {
            console.error(result.error);
        } else {
            const id = result.data.pulseCreate.pulse.id;
            navigate(`../pulse/${id}/results`);
        }
    };

    return <>
        <h1>{t('player.pulse-setup.heading')}</h1>
        <PulseForm onSubmit={onSubmit} pulseSuggestedQuestions={result.data.pulseSuggestedQuestions} />
    </>;
}

export default Setup;
